import { z } from 'my-zod'
import { damageWaiverCaseSystemView } from './damage-waiver-case-system-view'

export const updateDamageWaiverCaseSystemRequest = damageWaiverCaseSystemView.omit({
  closingReason: true,
  lifecycleStatus: true,
  partsOrders: true,
  lastModifiedByUserId: true,
  lastModifiedDate: true,
  deletedDate: true
})

export type updateDamageWaiverCaseSystemRequest = z.infer<typeof updateDamageWaiverCaseSystemRequest>
